import { jsx } from "react/jsx-runtime";
import { PaginationItem } from "@mui/material";
import { ChevronLeft } from "@nxt-costco-com/forge-icons/icons/ChevronLeft";
import { ChevronRight } from "@nxt-costco-com/forge-icons/icons/ChevronRight";
import { StyledPagination } from "./styles.js";
const COMPONENT_NAME = "Pagination";
const Pagination = ({
  count,
  defaultPage,
  disabled,
  getItemAriaLabel,
  handleChange,
  handleKeyDown,
  page,
  sx = []
}) => {
  return /* @__PURE__ */ jsx(
    StyledPagination,
    {
      "aria-label": "pagination",
      count,
      defaultPage,
      disabled,
      getItemAriaLabel,
      onChange: handleChange,
      page,
      sx: [...Array.isArray(sx) ? sx : [sx]],
      siblingCount: 1,
      boundaryCount: 1,
      onKeyDown: handleKeyDown,
      renderItem: (item) => /* @__PURE__ */ jsx(
        PaginationItem,
        {
          slots: { previous: ChevronLeft, next: ChevronRight },
          ...item
        }
      )
    }
  );
};
Pagination.displayName = COMPONENT_NAME;
export {
  Pagination
};
